/**
 * Maps a backend modified-image `sizeName` to the GA4 resolution string
 * (1k/2k/4k) used for asset_size / asset_sizes on Getty. The backend emits
 * low/medium/high (legacy alias `super`); the 1k/2k/4k spellings pass through
 * so fibo/pre-shot sizes that already arrive as resolutions are handled too.
 * Grouping mirrors modifiedSizeCopy.ts / ctaTracking.ts.
 *
 * Returns null for an unknown name so callers can drop stray sizes (e.g.
 * `tiny`) from the emitted list.
 */
const BY_SIZE_NAME: Record<string, string> = {
  low: '1k',
  '1k': '1k',
  medium: '2k',
  '2k': '2k',
  high: '4k',
  super: '4k', // legacy alias
  '4k': '4k',
};

const modifiedSizeResolution = (sizeName?: string): string | null =>
  (sizeName && BY_SIZE_NAME[sizeName]) || null;

export default modifiedSizeResolution;
